var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Field = (_a) => {
    var { forwardRef, value, onChange, onBlur, onFocus, label, name, type, error, valid, helperText, required, readOnly: readOnly, placeholder = '', inputProps = {} } = _a, props = __rest(_a, ["forwardRef", "value", "onChange", "onBlur", "onFocus", "label", "name", "type", "error", "valid", "helperText", "required", "readOnly", "placeholder", "inputProps"]);
    const classNames = [
        'c-field',
        ...error ? ['is-invalid'] : [],
        ...valid ? ['is-valid'] : [],
        ...readOnly ? ['c-field--readonly'] : [],
    ].join(' ');
    return (_jsxs("div", Object.assign({}, props, { className: classNames }, { children: [label && (_jsx("label", Object.assign({ className: "c-field__label", htmlFor: name }, { children: label }))), _jsx("div", Object.assign({ className: "c-field__inner" }, { children: _jsx("input", Object.assign({ ref: forwardRef, id: name, "aria-label": label, "aria-required": required ? 'true' : 'false' }, inputProps, readOnly ? { readOnly } : {}, placeholder ? { placeholder } : {}, type ? { type } : {}, required ? { required } : {}, onBlur ? { onBlur } : {}, onFocus ? { onFocus } : {}, { onChange: onChange, name: name, value: value })) })), helperText ? (_jsx("div", Object.assign({ className: "c-field__helper" }, { children: helperText }))) : null] })));
};
export { Field, };
